<template>
    <div class="form-group">
        <label>{{ label }}</label>
        <p>{{ value }}</p>
    </div>
</template>

<script>
import FormLabel from "./FormLabel";

export default {
    name: "FormConfirm",
    components: {FormLabel},
    props: {
        label: {
            type: String,
        },
        value: {
            type: String | Number,
        }
    }
}
</script>

<style scoped>
label {
    @apply text-main-color;
    width: 250px;
    padding-top: 10px;
    letter-spacing: 0.12em;
}

p {
    padding-top: 10px;
    letter-spacing: 0.12em;
}
</style>
